var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "proposal-evaluation-header" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "div",
          {
            staticClass:
              "col-12 col-md-9 proposal-evaluation-header__expectation"
          },
          [_vm._v(" Expectativa ")]
        ),
        _vm._l(_vm.values, function(value, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass:
                "col-4 col-md-1 proposal-evaluation-header__qualification",
              style: { "--bg-color": value.bgColor }
            },
            [_vm._v(" " + _vm._s(value.name) + " ")]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }